module.exports = __webpack_public_path__ + "static/media/survey-description-icon-bg.8ab0cd1f.svg";